import styled from 'styled-components'

export const MainTitleContainer = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}
    h3 {
        font-weight: bold;
        font-size: 20px;
        margin-top: 1.2em;
        small {
            font-weight: bold;
            font-size: 20px;
            color: var(--dashboard-main-color);
            margin-left: 10px;
        }
    }
    animation: fadeIn 0.8s ease-in-out;
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translate(0, -15px);
        }
        to {
            opacity: 1;
            transform: translate(0, 0);
        }
    }
`
